import {useEffect,useRef,useState} from 'react';
import {useProviderText} from './providerText';
import {centerApi} from './centerApi';
import {explain} from './centerFormat.mjs';
import {words,usablePrecheck} from './diagnosticEvidence.mjs';

export function CurrentModelStatus({provider,model}:{provider:string;model:string}){
 const {locale,time,pt}=useProviderText(),w=(key:string)=>words(key,locale);
 const [data,setData]=useState<any>(null),[busy,setBusy]=useState(false),[tick,setTick]=useState(0);
 const refresh=useRef<()=>void>(()=>{});
 useEffect(()=>{
  let live=true,active:AbortController|null=null,sequence=0;
  setData(null);
  const load=async()=>{
   if(!provider||!model)return;
   active?.abort();active=new AbortController();const request=active,seq=++sequence;
   setBusy(true);
   try{const next=await centerApi.model(provider,model,request.signal);
    if(live&&!request.signal.aborted&&seq===sequence)setData(next);
   }catch{if(live&&!request.signal.aborted&&seq===sequence)setData(null);}
   finally{if(live&&seq===sequence){setBusy(false);setTick(Date.now());}}
  };
  const run=()=>{void load();};refresh.current=run;run();
  const timer=setInterval(()=>{setTick(Date.now());if(document.visibilityState==='visible')run();},20000);
  window.addEventListener('pmc-refresh',run);
  return()=>{live=false;sequence++;active?.abort();clearInterval(timer);window.removeEventListener('pmc-refresh',run);};
 },[provider,model]);
 const current=usablePrecheck(data,provider,model,Math.max(tick,Date.now()));
 if(!provider||!model)return <p>{w('choose')}</p>;
 return <section className="pmc-provider" aria-label={w('current')} data-knsaix="pmc-current-precheck-v2">
  <div className="pmc-between"><h2>{w('current')}</h2><button type="button" disabled={busy} onClick={()=>refresh.current()}>{w('refresh')}</button></div>
  <p>{model}</p><p role="status">{busy?w('loading'):current?.status==='PASS'?w('pass'):current?.status==='BLOCKED'?w('blocked'):w('unknown')}</p>
  <dl className="pmc-fields"><div><dt>{w('memory')}</dt><dd>{current?.memory_allowed===true?w('allowed'):current?.memory_allowed===false?w('missing'):w('unchecked')}</dd></div>
   <div><dt>{w('observed')}</dt><dd>{data?.test_precheck?.observed_at?time(data.test_precheck.observed_at):w('unavailable')}</dd></div>
   <div><dt>{w('route')}</dt><dd>{current?pt(explain(data?.pm?.reason||'UNKNOWN')):w('unchecked')}</dd></div>
  </dl>
  {data&&!current&&<p>{w('stale')}</p>}
  {current?.reason&&<p>{pt(explain(current.reason))}</p>}
 </section>;
}

export function RecordedEvidence({row}:{row:any}){
 const {locale,time,pt}=useProviderText(),w=(key:string)=>words(key,locale),d=row.detail||{};
 const rate=d.http_status===429||d.error_code==='HTTP_429'||d.result_class==='RATE_LIMITED';
 const reported=d.retry_after_status==='REPORTED';
 return <div className="pmc-diagnosis-unknown">
  <p>{w('historical')}</p>
  {rate&&<><strong>{w('detail')}</strong><dl className="pmc-fields">
   <div><dt>{w('kind')}</dt><dd>{w(d.provider_error_kind)}</dd></div>
   <div><dt>{w('scope')}</dt><dd>{w(d.quota_scope)}</dd></div>
   <div><dt>{w('SOURCE')}</dt><dd>{w(d.provider_error_source)}</dd></div>
   <div><dt>{w('wait')}</dt><dd>{reported&&typeof d.retry_after_seconds==='number'?pt(d.retry_after_seconds):w('unavailable')}</dd></div>
   <div><dt>{w('retry')}</dt><dd>{reported&&d.retry_not_before?time(d.retry_not_before):w('unavailable')}</dd></div>
   <div><dt>{w('clock')}</dt><dd>{w(d.retry_clock_reference)}</dd></div>
   <div><dt>{w('start')}</dt><dd>{d.probe_started_at?time(d.probe_started_at):w('unavailable')}</dd></div>
   <div><dt>{w('finish')}</dt><dd>{d.probe_finished_at?time(d.probe_finished_at):w('unavailable')}</dd></div>
  </dl>{!d.diagnostic_version&&<p>{w('legacy')}</p>}
  {d.retry_after_status==='INVALID_OR_UNSUPPORTED'&&<p>{w('invalid')}</p>}
  <p>{w('caution')}</p></>}
 </div>;
}
